var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 222"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval 23 Copy",
    cx: 9,
    cy: 9,
    r: 8,
    stroke: "#D0423B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 7",
    d: "M6.29965 6.30002L11.6999 11.6999",
    stroke: "#D0423B",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 8",
    d: "M11.7002 6.06128L6.06157 11.6997",
    stroke: "#D0423B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircle);
export default __webpack_public_path__ + "static/media/error-circle.a626ecc8fb4282a1654bea6e8efe2d9d.svg";
export { ForwardRef as ReactComponent };